import { useSelector } from "react-redux";
import { createContext, useMemo, FC, ReactNode } from "react";

import { RootState } from "store";
import { createAuthorizationConfig } from "config/authorization.config";

const initialAbility = createAuthorizationConfig(null);

export const AbilityContext = createContext(initialAbility);

interface AuthorizationGuardProps {
  children: ReactNode;
}

export const AuthorizationGuard: FC<AuthorizationGuardProps> = ({ children }) => {
  const { user } = useSelector((state: RootState) => state.auth);

  const ability = useMemo(() => {
    return createAuthorizationConfig(user);
  }, [user]);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};
